/**
 * When "Complete your setup" is checked, adds main product + bundle metafield variant in one /cart/add.js request.
 */
(function () {
  function formDataToCartItem(form) {
    var fd = new FormData(form);
    var id = parseInt(fd.get('id'), 10);
    if (!id || isNaN(id)) return null;
    var qty = parseInt(fd.get('quantity') || '1', 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    var item = { id: id, quantity: qty };
    var sp = fd.get('selling_plan');
    if (sp) {
      var spId = parseInt(sp, 10);
      if (!isNaN(spId)) item.selling_plan = spId;
    }
    var properties = {};
    fd.forEach(function (val, key) {
      if (key.indexOf('properties[') === 0 && key[key.length - 1] === ']') {
        if (val !== '') properties[key.slice(11, -1)] = val;
      }
    });
    if (Object.keys(properties).length) item.properties = properties;
    return item;
  }

  function showFormError(form, message) {
    var holder = form.closest('product-form');
    if (holder) holder = holder.querySelector('[data-cart-errors-container]');
    if (!holder) return;
    holder.classList.add('is-visible');
    holder.innerHTML =
      '<div class="errors" data-error role="alert">' +
      message +
      '<button type="button" class="errors__button-close" data-close-error>' +
      (window.theme && theme.icons && theme.icons.close ? theme.icons.close : '×') +
      '</button></div>';
    var close = holder.querySelector('[data-close-error]');
    if (close) {
      close.addEventListener('click', function () {
        holder.classList.remove('is-visible');
        holder.innerHTML = '';
      });
    }
  }

  function clearFormError(form) {
    var holder = form.closest('product-form');
    if (holder) holder = holder.querySelector('[data-cart-errors-container]');
    if (holder) {
      holder.classList.remove('is-visible');
      holder.innerHTML = '';
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      var btn = target.closest && target.closest('[data-add-to-cart]');
      if (!btn) return;
      if (btn.closest('[data-product-form-upsell]')) return;

      var form = btn.closest('form[data-product-form]');
      if (!form) return;
      if (form.querySelector('[type="file"]')) return;

      var productForm = form.closest('product-form');
      var productComponent = productForm && productForm.closest('product-component');
      if (!productComponent) return;

      var bundle = productComponent.querySelector('[data-bundle-setup][data-bundle-variant-id]');
      if (!bundle) return;

      var cb = bundle.querySelector('[data-bundle-setup-checkbox]');
      if (!cb || !cb.checked) return;

      var bundleId = parseInt(bundle.getAttribute('data-bundle-variant-id'), 10);
      if (!bundleId || isNaN(bundleId)) return;

      var mainItem = formDataToCartItem(form);
      if (!mainItem) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      clearFormError(form);

      var cartDrawerEnabled = window.theme && window.theme.settings && window.theme.settings.cartType === 'drawer';
      if (cartDrawerEnabled) {
        btn.classList.add('is-loading');
        btn.setAttribute('disabled', 'true');
      }

      var items = [mainItem, { id: bundleId, quantity: 1 }];

      fetch(window.theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          return res.json().then(function (json) {
            return { ok: res.ok, status: res.status, json: json };
          });
        })
        .then(function (result) {
          var j = result.json;
          var failed = !result.ok || result.status === 422 || (j && j.errors);
          if (failed) {
            var desc = j && j.description;
            if (typeof desc === 'string') {
              showFormError(form, (j.message || 'Error') + ': ' + desc);
            } else if (desc && typeof desc === 'object') {
              showFormError(
                form,
                Object.keys(desc)
                  .map(function (k) {
                    return desc[k];
                  })
                  .join('<br>')
              );
            } else if (j && j.errors) {
              showFormError(form, typeof j.errors === 'string' ? j.errors : JSON.stringify(j.errors));
            } else {
              showFormError(form, (j && j.message) || 'Could not add to cart');
            }
            btn.classList.remove('is-loading');
            btn.removeAttribute('disabled');
            return;
          }

          if (cartDrawerEnabled) {
            var cartEl = document.querySelector('cart-element[data-cart-drawer]');
            if (cartEl && typeof cartEl.getCart === 'function') {
              cartEl.getCart();
            } else {
              btn.classList.remove('is-loading');
              btn.removeAttribute('disabled');
            }
          } else {
            window.location.href = window.theme.routes.cart_url;
          }
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.removeAttribute('disabled');
          showFormError(form, 'Could not add to cart');
        });
    },
    true
  );
})();
